import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate
import config from "../../config";
import { jwtDecode } from "jwt-decode";
import { useAppContext } from "../../context/AppContext";

const Login = ({ setIsLoggedIn }) => {
  // Accept setIsLoggedIn as prop
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate
  const { dispatch } = useAppContext();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Make a POST request to the backend login route
      const response = await fetch(`${config.apiBaseUrl}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ phone_number: phoneNumber, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // console.log("Login successful:", data);
        // Store accessToken and refreshToken data in local storage
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        // localStorage.setItem("user", JSON.stringify(data.user)); //  Always stringify object
        // localStorage.setItem("user_role", JSON.stringify(data.user.role)); // Always stringify object
        // localStorage.setItem("full_name", JSON.stringify(data.user.full_name)); // Always stringify object
        // localStorage.setItem("email", JSON.stringify(data.user.email)); // Always stringify object
        // localStorage.setItem(
        //   "is_volunteer",
        //   JSON.stringify(data.user.is_volunteer)
        // ); // Always stringify object

        //  Decode token and store in context
        const decoded = jwtDecode(data.accessToken);
        dispatch({ type: "SET_USER", payload: decoded });

        // Update isLoggedIn state
        setIsLoggedIn(true);

        // if login success then remove redirectTo
        if (localStorage.getItem("redirectTo") == "/login") {
          console.log("Removed:", localStorage.getItem("redirectTo"));
          localStorage.removeItem("redirectTo");
        }

        // const role = JSON.parse(localStorage.getItem("user_role"));
        const role = decoded?.role;

        // console.log("role", JSON.parse(localStorage.getItem("user_role")));

        let redirectTo;

        if (role === "donor") {
          // redirectTo = "/user/account-settings";
          redirectTo = "/user/confirmation";
        } else {
          // Retrieve the redirectTo URL from localStorage or fallback to dashboard
          redirectTo = localStorage.getItem("redirectTo") || "/user/dashboard";
        }

        localStorage.removeItem("redirectTo"); // Clear redirectTo after using it

        // Redirect to the appropriate page
        navigate(redirectTo);
      } else {
        setErrorMessage(data.message); // Display error message if login fails
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
      console.error("Error during login:", error);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="card log-card p-4">
        <div className="mb-4">
          <div className="text-center">
            <img
              src="/icon/main-logo-full-min.webp"
              alt="Logo"
              className="img-fluid mb-3 rounded-circle"
              width="140"
            />
          </div>
          <h5 className="card-title log-title">Welcome Back to Folk ERP</h5>
          <p className="text-muted">
            Please enter your credentials to log in to your account.
          </p>
        </div>
        <form onSubmit={handleLogin} className="text-start">
          <div className="mb-3">
            <label htmlFor="phone_number" className="form-label">
              Phone Number
            </label>
            <input
              type="text"
              className="form-control"
              id="phone_number"
              placeholder="Phone Number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            {/* Forgot Password? <Link to="/user/forgot-password">Click here</Link> */}
            <Link to="/user/forgot-password">Forgot Password?</Link> Click here
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="rememberMe"
            />
            <label className="form-check-label" htmlFor="rememberMe">
              Remember me
            </label>
          </div>
          <button type="submit" className="btn w-100 theme-button">
            Login
          </button>
          {errorMessage && (
            <div className="text-danger mt-2">{errorMessage}</div>
          )}{" "}
          {/* Display error message */}
        </form>
      </div>
    </div>
  );
};

export default Login;
